import React from 'react'
import cx from 'classnames'
import { ResponsivePie } from '@nivo/pie'
import styles from './PieChart.scss'

const chartColors = ['#79A2F8', '#0D47A1', '#2155c0', '#495FA6']

interface PieChartDataItem {
  id: string
  label?: string
  value: number
  color?: string | number
}

interface PieChartProps {
  data: PieChartDataItem[]
  isInteractive?: boolean
  children?: React.ReactNode
  className?: string
  innerClassName?: string
}

export const PieChart: React.FC<PieChartProps> = ({ 
  data, 
  isInteractive = false, 
  children, 
  className, 
  innerClassName 
}) => (
  <div className={cx(styles.pieContainer, className)}>
    {!!children && <span className={cx(styles.inner, innerClassName)}>{children}</span>}
    <ResponsivePie
      data={data}
      margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
      innerRadius={0.95}
      padAngle={2}
      cornerRadius={45}
      colors={chartColors}
      enableRadialLabels={false}
      enableSlicesLabels={false}
      animate
      motionStiffness={90}
      motionDamping={15}
      isInteractive={isInteractive}
    />
  </div>
)

